<!-- eslint-disable no-else-return -->
<template>
    <div>
        <approval
            ref="approval"
            :approvalTitle="approvalTitle"
            :showApproval="showApproval"
            @handleDeelSubmit="handleDeelSubmit"
            @handlerSubmit="handlerSubmit"
            @afterProcessSubmit="afterProcessSubmit"
            @handleReturnBtn="handleReturnBtn"
            >
            <div class="layout" id="panel_1">
                <Form
                    ref="suppForm"
                    :model="suppForm"
                    :rules="suppFormRules"
                    :label-width="110">
                    <Row>
                        <template v-if="!businessId">
                            <Col span="8">
                                <!--库存组织-->
                                <FormItem :label="$t('createDeliveryOrderByOrder.t1')" prop="organizationCode">
                                    <Select
                                        v-model="suppForm.organizationCode"
                                        size="small"
                                        :filterable="true"
                                        :disabled="headerDisabled"
                                        :clearable="true"
                                        @on-change="orgOnChange">
                                        <Option v-for="item in orgList" :value="item.value" :key="item.value">{{item.label}}
                                        </Option>
                                    </Select>
                                </FormItem>
                            </Col>
                        </template>
                        <template v-else>
                            <Col span="8">
                                <!--库存组织-->
                                <FormItem :label="$t('createDeliveryOrderByOrder.t1')" prop="organizationCode">
                                    <Input size="small" disabled v-model="suppForm.organizationCode"></Input>
                                </FormItem>
                            </Col>
                        </template>
                        <Col span="8">
                            <!--请领模式-->
                            <FormItem :label="$t('suppliesFormOutside.t1')" prop="wxMode">
                                <Select
                                    v-model="suppForm.wxMode"
                                    size="small"
                                    :disabled="headerDisabled"
                                    @on-change="wxModeChange">
                                    <Option v-for="item in INT_REQ_MODE" :value="item.value" :key="item.value">{{item.label}}
                                    </Option>
                                </Select>
                            </FormItem>
                        </Col>
                        <Col span="8">
                            <!--单据类型-->
                            <FormItem :label="$t('purchaseDistribution.djlx')" prop="orderType">
                                <Select
                                    v-model="suppForm.orderType"
                                    size="small"
                                    :disabled="headerDisabled || !factoryType"
                                    placeholder="">
                                    <Option v-for="item in orderTypeFilter" :value="item.value" :key="item.value">{{item.label}}
                                    </Option>
                                </Select>
                            </FormItem>
                        </Col>
                    </Row>
                    <Row>
                        <template v-if="!factoryType">
                            <Col span="8">
                                <!--供方联系人-->
                                <FormItem :label="$t('suppliesFormOutside.t13')" prop="contacts">
                                    <Input
                                        v-model.trim="suppForm.contacts"
                                        size="small"
                                        :disabled="readOnly || !isDRAFT">
                                    </Input>
                                </FormItem>
                            </Col>
                            <Col span="8">
                                <!--供方联系电话-->
                                <FormItem :label="$t('suppliesFormOutside.t14')" prop="phone">
                                    <Input
                                        v-model.trim="suppForm.phone"
                                        size="small"
                                        :disabled="readOnly || !isDRAFT">
                                    </Input>
                                </FormItem>
                            </Col>
                            <Col span="8">
                                <!--地点-->
                                <FormItem :label="$t('ApplyReceiveMgnView.ADDRESS')" prop="address">
                                    <Input
                                        v-model.trim="suppForm.address"
                                        size="small"
                                        :disabled="readOnly || !isDRAFT">
                                    </Input>
                                </FormItem>
                            </Col>
                        </template>
                        <Col span="8" v-if="needApproval">
                            <!--采购员-->
                            <FormItem :label="$t('importNoticeCommon.t52')" prop="approvalUser">
                                <!-- <Input
                                    v-model.trim="suppForm.approvalUser"
                                    icon="search"
                                    size="small"
                                    :disabled="readOnly"
                                    @click="approveModal.show = true">
                                </Input> -->
                                <Select
                                    v-model="suppForm.approvalUser"
                                    size="small"
                                    :disabled="readOnly || !isDRAFT || suppForm.approvalStatus === 'REJECED'">
                                    <Option v-for="item in approvalList" :value="item.value" :label="item.label" :key="item.value"></Option>
                                </Select>
                            </FormItem>
                        </Col>
                        <Col span="8">
                            <!--审批状态-->
                            <FormItem :label="$t('suppliesFormOutside.t6')" prop="approvalStatus">
                                <Select
                                    v-model="suppForm.approvalStatus"
                                    size="small"
                                    disabled
                                    placeholder="">
                                    <Option v-for="item in INT_REQ_APPROVED_STATUS" :value="item.value" :key="item.value">{{item.label}}
                                    </Option>
                                </Select>
                            </FormItem>
                        </Col>
                        <Col span="8">
                            <!--单据状态-->
                            <FormItem :label="$t('suppliesFormOutside.t5')" prop="status">
                                <Select
                                    v-model="suppForm.status"
                                    size="small"
                                    disabled
                                    placeholder="">
                                    <Option v-for="item in INT_REQ_STATUS" :value="item.value" :key="item.value">{{item.label}}
                                    </Option>
                                </Select>
                            </FormItem>
                        </Col>
                    </Row>
                    <Row>
                        <Col span="8">
                            <!--请领单号-->
                            <FormItem :label="$t('suppliesFormOutside.t4')" prop="requestLeadCode">
                                <Input
                                    v-model.trim="suppForm.requestLeadCode"
                                    size="small"
                                    disabled>
                                </Input>
                            </FormItem>
                        </Col>
                        <Col span="8" v-if="!factoryType">
                            <!--柜号-->
                            <FormItem :label="$t('suppliesFormOutside.t7')" prop="containers">
                                <Input
                                    v-model.trim="suppForm.containers"
                                    size="small"
                                    disabled>
                                </Input>
                            </FormItem>
                        </Col>
                         <Col span="8">
                            <!--报关状态-->
                            <FormItem :label="$t('suppliesFormOutside.t35')" prop="imptStatus">
                                 <Select
                                    v-model="suppForm.imptStatus"
                                    size="small"
                                    disabled
                                    placeholder="">
                                    <Option v-for="item in INT_WX_IMPT_STATUS" :value="item.value" :key="item.value">{{item.label}}
                                    </Option>
                                </Select>
                            </FormItem>
                        </Col>
                    </Row>
                </Form>

                <div class="tr" v-if="!isReject">
                    <!--返回-->
                    <Button type="default" class="mr10" @click="back">{{$t('common.back')}}</Button>
                    <!--保存-->
                    <Button v-if="!readOnly && !factoryType && isDRAFT && headerId" type="primary" class="mr10" :loading="loading" @click="updateHeader">{{$t('common.saveBtn')}}</Button>
                    <!--提交-->
                    <Button
                        v-if="!readOnly"
                        type="primary"
                        :disabled="cNoMod.tableData.length === 0 && factoryMod.tableData.length === 0 || !isDRAFT"
                        :loading="loading"
                        @click="submit">
                        {{$t('common.commit')}}
                    </Button>
                </div>
                <!--直送供方-->
                <template v-if="!factoryType">
                    <Tabs :animated="false" v-model="tabVal">
                        <!--单据详情-->
                        <TabPane :label="$t('suppliesFormOutside.t15')" name="1">
                            <template v-if="!readOnly && isDRAFT || isReject">
                                <!--新增-->
                                <Button type="primary" class="mr10" @click="cNoModalAdd">{{$t('common.newBtn')}}</Button>
                                <!--删除-->
                                <Button type="error" class="mr10" :loading="loading" :disabled="cNoMod.selection.length === 0" @click="removeContainer">{{$t('common.delBtn')}}</Button>
                            </template>
                            <!--导出-->
                            <Button v-if="headerId" type="primary" class="mr10" :loading="loading" @click="exportLine">{{$t('common.export')}}</Button>
                            <!--按柜可领料数量-->
                            <span class="c1">{{$t('suppliesFormOutside.t19')}}：{{currentQtyTotal}}</span>

                            <!--货柜详情-->
                            <custom-panel class="mt10">
                                {{$t('suppliesFormOutside.t25')}}
                                <template slot="content">
                                    <Table
                                        v-if="tabVal === '1'"
                                        ref="cNoTable"
                                        size="small"
                                        thDrag
                                        highlight-row
                                        border
                                        :height="400"
                                        :columns="cNoMod.columns"
                                        :data="cNoMod.tableData"
                                        :loading="loading"
                                        @on-select-all="cNoSelectAll"
                                        @on-selection-change="cNoSelectAllCancel"
                                        @on-select="cNoSelect"
                                        @on-select-cancel="cNoSelectCancel">
                                    </Table>
                                </template>
                            </custom-panel>

                            <!--外协工单详情-->
                            <custom-panel class="mt10">
                                {{$t('suppliesFormOutside.t24')}}
                                <template slot="content">
                                    <Table
                                        size="small"
                                        thDrag
                                        highlight-row
                                        border
                                        :height="400"
                                        :columns="wxMod.columns"
                                        :data="wxMod.tableData"
                                        :loading="loading"
                                        >
                                    </Table>
                                </template>
                            </custom-panel>
                        </TabPane>

                        <!--采购订单详情-->
                        <TabPane :label="$t('suppliesFormOutside.t16')" name="2">
                            <template v-if="!readOnly || isReject">
                                <!--手工添加采购订单-->
                                <Button type="primary" class="mr10" v-if="poManualSwitch && this.headerId" @click="poModal.show2 = true">{{$t('suppliesFormOutside.t23')}}</Button>
                                <!--删除-->
                                <Button type="primary" class="mr10" :disabled="poMod.selection.length === 0" v-if="this.headerId" :loading="loading" @click="removePo">{{$t('common.delBtn')}}</Button>
                                <!--更新数量-->
                                <Button type="primary" class="mr10" :disabled="poMod.selection.length === 0" v-if="this.headerId" :loading="loading" @click="updatePo">{{$t('suppliesFormOutside.t38')}}</Button>
                            <!--导入采购订单-->
                            </template>

                            <!--采购订单-->
                            <Table
                                ref="poModTabRef"
                                v-if="tabVal === '2'"
                                class="mt10"
                                size="small"
                                thDrag
                                highlight-row
                                border
                                :height="400"
                                :columns="poMod.columns"
                                :data="poMod.tableData"
                                :loading="loading"
                                @on-selection-change="poModSelect"
                                >
                            </Table>
                        </TabPane>
                    </Tabs>
                </template>
                <!--工厂领料-->
                <template v-else>
                    <template v-if="!readOnly">
                        <!--新增-->
                        <Button type="primary" class="mr10" @click="factoryModalOpen">{{$t('common.newBtn')}}</Button>
                        <!--删除-->
                        <Button type="error" class="mr10" :disabled="factoryMod.selection.length === 0" @click="removeFactory">{{$t('common.delBtn')}}</Button>
                    </template>
                    <!--导出-->
                    <Button v-else type="primary" class="mr10" :loading="loading" @click="exportWxRefund">{{$t('common.export')}}</Button>
                    <!--请领数量汇总-->
                    <span class="c1">{{$t('suppliesFormOutside.t26')}}：{{factoryModQtyTotal}}</span>

                    <Table
                        class="mt10"
                        size="small"
                        thDrag
                        highlight-row
                        border
                        :height="400"
                        :columns="factoryMod.columns"
                        :data="factoryMod.tableData"
                        :loading="loading"
                        @on-selection-change="factoryModSelectChange"
                        >
                    </Table>
                </template>
            </div>
        </approval>
        <!--新增柜号-->
        <Modal
            :title="$t('suppliesFormOutside.t29')"
            v-model="cNoModal.show"
            :width="1200"
            :mask-closable="false"
            >
            <Form
                ref="cNoForm"
                :model="cNoModal.form"
                :rules="cNoModal.rules"
                :label-width="100">
                <Row>
                    <Col :span="12">
                        <!--柜号-->
                        <FormItem :label="$t('suppliesFormOutside.t7')" prop="containers">
                            <Input
                                v-model.trim="cNoModal.form.containers"
                                style="width:200px;">
                            </Input>
                        </FormItem>
                    </Col>
                    <Col :span="8">&nbsp;</Col>
                    <Col :span="4">
                        <!--查询-->
                        <Button type="primary" :loading="cNoModal.loading" @click="queryInvoice">{{$t('page.query.search')}}</Button>
                    </Col>
                </Row>
            </Form>
            <div class="mt10">
                <!--导出-->
                <Button type="primary" :loading="cNoModal.loading" class="mr10" @click="cNoModalExport">{{$t('common.export')}}</Button>
                <Button type="primary" :loading="cNoModal.loading" :disabled="cNoModal.selection.length === 0" class="mr10" @click="cNoModalConfirm">{{$t('common.submitBtn')}}</Button>
            </div>
            <Table
                v-if="cNoModal.show"
                ref="cNoModalTab"
                class="mt10"
                size="small"
                thDrag
                highlight-row
                border
                :columns="cNoModal.columns"
                :data="cNoModal.tableData"
                :loading="cNoModal.loading"
                @on-selection-change="cNoModalSelectChange"
                >
            </Table>
            <div slot="footer">
                <!--确定-->
                <!-- <Button type="primary" class="mr10" :disabled="cNoModal.selection.length === 0">{{$t('common.submitBtn')}}</Button> -->
                <!--取消-->
                <!-- <Button type="default" @click="cNoModal.show = false">{{$t('common.cancelBtn')}}</Button> -->
            </div>
        </Modal>
        <!--工厂领料新增-->
        <Modal
            v-model="factoryModal.show"
            :width="1300"
            :mask-closable="false"
            :closable="false">
            <m-assembly-table
                ref='factoryModalTab'
                columnDrag
                thDrag
                :formData='factoryModal.formData'
                :columns='factoryModalColumns'
                :data='factoryModal.tableData'
                :loading='factoryModal.loading'
                :settings='factoryModal.settings'
                :tableButtons="factoryModal.tableButtons"
                @onSubmit='factOnSubmit'
                @onSelectionChange="factOnSelectionChange">
            </m-assembly-table>
            <div slot="footer">
                <!--确定-->
                <Button type="primary" class="mr10" :disabled="factoryModal.selection.length === 0" @click="factoryConfirm">{{$t('common.submitBtn')}}</Button>
                <!--取消-->
                <Button type="default" @click="factoryModal.show = false">{{$t('common.cancelBtn')}}</Button>
            </div>
        </Modal>

        <!--手工新增采购订单-->
        <Modal
            v-model="poModal.show2"
            :width="1230"
            :mask-closable="false"
            :closable="false">
            <m-assembly-table
                ref='poModalTable'
                columnDrag
                thDrag
                :formData='poModal.formData'
                :loading='poModal.loading'
                :settings='poModal.settings'
                hideTable
                @onSubmit='poModalOnSubmit'>
            </m-assembly-table>

            <!--一键维护柜号-->
            <Button type="primary" :disabled="containerList.length === 0 || poModal.tableData.length === 0" @click="containerSetModal.show = true" class="mr10">{{$t('suppliesFormOutside.t36')}}</Button>
            <!--汇总数量-->
            <span class="c1">{{$t('fpzLiabilitySearch.t13')}}：{{poNumCount}}</span>
            <ag-grid
                style="margin-top:20px;"
                ref="gridRef"
                height="400"
                :isCard="false"
                :columnsForIview="poModal.columns"
                :loading="poModal.loading"
                :rowData="poModal.tableData"
                rowSelection='multiple'
                isNeedScrollBar
                @selection-change="poModalSelect"
                @onFirstDataRendered="onFirstDataRendered"
                @onRowDataUpdated="onRowDataUpdated"
            >
            </ag-grid>
            <div slot="footer">
                <!--确定-->
                <Button type="primary" class="mr10" :disabled="poModal.selection.length === 0" @click="poModalConfirm">{{$t('common.submitBtn')}}</Button>
                <!--取消-->
                <Button type="default" @click="poModal.show2 = false">{{$t('common.cancelBtn')}}</Button>
            </div>
        </Modal>

        <!--一键维护柜号-->
        <Modal
            v-model="containerSetModal.show"
            :width="300"
            :title="$t('suppliesFormOutside.t36')"
            :mask-closable="false"
        >
            <Select v-model="containerSetModal.container">
                <Option v-for="item in containerList" :label="item" :value="item" :key="item"></Option>
            </Select>

            <div slot="footer">
                <!--确定-->
                <Button type="primary" class="mr10" :disabled="!containerSetModal.container" @click="containerSet">{{$t('common.submitBtn')}}</Button>
                <!--取消-->
                <Button type="default" @click="containerSetModal.show = false">{{$t('common.cancelBtn')}}</Button>
            </div>
        </Modal>
    </div>
</template>
<script>
import CustomPanel from '@/components/awesome/page/panel';
import mAssemblyTable from '@/components/awesome/page/assembly_table';
import approval from '@/modules/globalprotal/views/approval/index.vue';
import axios from 'axios';
import { langParams, exportExcel } from '@/utils/tool';
import moment from 'moment';
import BigNumber from 'bignumber.js';
import AgGrid from '@/components/ag-grid/index.vue';
import mixin from './suppliesFormOutside/index';

export default {
    name: 'suppliesFormOutsideCommon',
    components: {
        CustomPanel,
        mAssemblyTable,
        approval,
        AgGrid,
    },
    mixins: [mixin],
    props: {
        readOnly: {
            type: Boolean,
            default: () => false,
        },
    },
    computed: {
        /* 工厂领料模式 */
        factoryType() {
            return this.suppForm.wxMode === 'FACTORY_MATERIAL_REQUISITION';
        },
        businessId() {
            return this.$route.query.businessId;
        },
        headerId() {
            return this.$route.query.headerId;
        },
        showApproval() {
            return Boolean(this.businessId);
        },
        /* 审批人 */
        approvalList() {
            return this.INT_WX_BUYER_APPROVED.filter((item) => item.label === this.suppForm.organizationCode).map((it) => {
                return {
                    label: it.email,
                    value: it.attribute1,
                };
            });
        },
        headerDisabled() {
            return this.readOnly || Boolean(this.headerId);
        },
        isDRAFT() {
            return ['DRAFT', 'REJECED', ''].includes(this.suppForm.approvalStatus);
        },
        /* 手工新增采购订单开关 */
        poManualSwitch() {
            return this.INT_WXQL_MANUALLY_ADD_PO.some((item) => item.value === this.suppForm.organizationCode);
        },
        currentQtyTotal() {
            return this.cNoMod.tableData.reduce((prev, next) => {
                return new BigNumber(prev).plus(next.currentQty).toNumber();
            }, 0);
        },
        /* 根据模式过滤单据类型 */
        orderTypeFilter() {
            return this.orderType;
            // return this.orderType.filter((item) => {
            //     return this.factoryType ? item.value === 3 : item.value !== 3;
            // });
        },
        isReject() {
            return Boolean(this.$route.query.reject);
        },
        approvalTitle() {
            return `${this.$t('suppliesFormOutside.t33')}【${this.$t('TransferApplication.TransferNumber')}：${this.suppForm.requestLeadCode}】`;
        },
        containerList() {
            return Array.from(new Set([...this.cNoMod.tableData.map((item) => item.container)]));
        },
        poNumCount() {
            return this.poModal.selection.reduce((prev, next) => {
                return prev + +next.qty;
            }, 0);
        },
        factoryModQtyTotal() {
            return this.factoryMod.tableData.reduce((prev, next) => {
                return prev + +next.qty;
            }, 0);
        },
        /* 是否需要审批 */
        needApproval() {
            const obj = this.INT_WX_NO_APPROVE.find((item) => item.code === this.suppForm.organizationCode)
            if (!obj) {
                return true;
            } else {
                const { orderType } = this.suppForm;
                const  { attribute1, attribute2, attribute3 } = obj;
                if (attribute1 == orderType || attribute2 == orderType || attribute3 == orderType) {
                    return false;
                } else {
                    return true;
                }
            }
        },
        factoryModalColumns() {
            return {
                columns: this.factoryModal.columns.columns.filter(item => item.key !== 'totalSendQty'),
            };
        },
    },
    watch: {
        // eslint-disable-next-line object-shorthand
        'cNoModal.show'(val) {
            if (val) {
                Object.assign(this.cNoModal, {
                    tableData: [],
                    selection: [],
                    form: {
                        containers: '',
                    },
                });
            }
        },
        // eslint-disable-next-line object-shorthand
        'poModal.show2'(val) {
            if (val) {
                Object.assign(this.poModal, {
                    show: false,
                    selection: [],
                    tableData: [],
                });
            }
        },
        // eslint-disable-next-line object-shorthand
        'factoryModal.show'(val) {
            if (val) {
                Object.assign(this.factoryModal, {
                    tableData: [],
                    selection: [],
                });
            }
        },
        // eslint-disable-next-line object-shorthand
        'containerSetModal.show'(val) {
            if (val) {
                this.containerSetModal.container = '';
            }
        },
    },
    data() {
        const orderTypeVaild = (rule, value, cb) => {
            if (!this.factoryType) {
                cb();
            } else {
                // eslint-disable-next-line no-lonely-if
                if (!value) {
                    cb(new Error(this.$t('gscInvoice.t104')));
                }
            }
            cb();
        };
        return {
            INT_WX_RECEIVE_MATERIAL: [],
            INT_WX_NO_APPROVE: [],
            containerSetModal: {
                show: false,
                container: '',
            },
            tabVal: '1',
            isRowSelectable: null,
            suppForm: {
                organizationCode: '',
                wxMode: '',
                orderType: '',
                contacts: '',
                phone: '',
                approvalUser: '',
                approvalStatus: '',
                status: '',
                requestLeadCode: '',
                containers: '',
            },
            suppFormRules: {
                organizationCode: [
                    { required: true, message: this.$t('gscInvoice.t104'), trigger: 'change' },
                ],
                wxMode: [
                    { required: true, message: this.$t('gscInvoice.t104'), trigger: 'change' },
                ],
                orderType: [
                    { validator: orderTypeVaild, trigger: 'change' },
                ],
                contacts: [
                    { required: true, message: this.$t('gscInvoice.t104'), trigger: 'change' },
                ],
                phone: [
                    { required: true, message: this.$t('gscInvoice.t104'), trigger: 'change' },
                ],
                address: [
                    { required: true, message: this.$t('gscInvoice.t104'), trigger: 'change' },
                ],
                approvalUser: [
                    { required: true, message: this.$t('gscInvoice.t104'), trigger: 'change' },
                ],
            },
            INT_REQ_MODE: [],
            // approveModal: {
            //     show: false,
            // },
            loading: false,
            cNoMod: {
                columns: [
                    {
                        type: 'selection',
                        width: 35,
                        align: 'center',
                    },
                    {
                        title: this.$t('suppliesFormOutside.t7'), // 柜号
                        key: 'container',
                        minWidth: 150,
                        align: 'center',
                    },
                    {
                        title: this.$t('ApplyReceiveMgnView.ITEM_CODE'), // 材料编码
                        key: 'itemCode',
                        minWidth: 150,
                        align: 'center',
                    },
                    {
                        title: this.$t('ApplyReceiveMgnView.ITEM_NAME'), // 材料描述
                        key: 'itemDesc',
                        minWidth: 200,
                        tooltip: true,
                    },
                    {
                        title: this.$t('invoiceMonitoring.t13'), // 采购订单数量
                        key: 'ipoQty',
                        minWidth: 60,
                        align: 'right',
                    },
                    {
                        title: this.$t('suppliesFormOutside.t17'), // 本次领料数量
                        key: 'currentQty',
                        minWidth: 60,
                        align: 'right',
                    },
                    {
                        title: this.$t('suppliesFormOutside.t18'), // OMS发票数量
                        key: 'singQty',
                        minWidth: 60,
                        align: 'right',
                    },
                    {
                        title: this.$t('importNoticeCommon.t144'), // OMS发票号
                        key: 'omsInvoiceNo',
                        minWidth: 150,
                        align: 'center',
                    },
                ],
                tableData: [],
                selection: [],
            },
            wxMod: {
                columns: [
                    {
                        title: this.$t('suppliesFormOutside.t20'), // 外协工单号
                        key: 'wipEntityName',
                        minWidth: 100,
                        align: 'center',
                    },
                    {
                        title: this.$t('createDeliveryOrderByOrder.t20'), // 需求时间
                        key: 'needByDate',
                        minWidth: 100,
                        align: 'center',
                    },
                    {
                        title: this.$t('ApplyReceiveMgnView.ITEM_CODE'), // 材料编码
                        key: 'itemCode',
                        minWidth: 100,
                        align: 'center',
                    },
                    {
                        title: this.$t('ApplyReceiveMgnView.COLLECT_NEED_QTY'), // 需求数量
                        key: 'needByQty',
                        minWidth: 100,
                        align: 'right',
                    },
                    {
                        title: this.$t('ApplyReceiveMgnView.ISSUED_QTY'), // 已制单数量
                        key: 'usedQty',
                        minWidth: 100,
                        align: 'right',
                    },
                    {
                        title: this.$t('ApplyReceiveMgnView.WIP_QTY'), // 已发料量
                        key: 'sendQty',
                        minWidth: 100,
                        align: 'right',
                    },
                    {
                        title: this.$t('ApplyReceiveMgnView.NOT_QTY'), // 未领料数量
                        key: 'remainQty',
                        minWidth: 100,
                        align: 'right',
                    },
                    {
                        title: this.$t('ApplyReceiveMgnView.THIS_TIME_QTY2'), // 本次领/退料数量
                        key: 'qty',
                        minWidth: 100,
                        align: 'right',
                    },
                    {
                        title: this.$t('suppliesFormOutside.t21'), // 超领量
                        key: 'overQty',
                        minWidth: 100,
                        align: 'right',
                    },
                    {
                        title: this.$t('ApplyReceiveMgnView.PRIMARY_ITEM_CODE'), // 装配件编码
                        key: 'goodsCode',
                        minWidth: 100,
                        align: 'center',
                    },
                    {
                        title: this.$t('suppliesFormOutside.t22'), // 装配件名称
                        key: 'goodsName',
                        minWidth: 150,
                        tooltip: true,
                    },
                    {
                        title: this.$t('ApplyReceiveMgnView.STATUS_TYPE'), // 工单状态
                        key: 'entityStatus',
                        minWidth: 100,
                        align: 'center',
                    },
                ],
                tableData: [],
            },
            poMod: {
                columns: [
                    {
                        type: 'selection',
                        width: 35,
                        align: 'center',
                    },
                    {
                        title: this.$t('createDeliveryOrderByOrder.t3'), // 采购订单号
                        key: 'ierpPoNo',
                        minWidth: 100,
                        align: 'center',
                    },
                    {
                        title: this.$t('ApplyReceiveMgnView.NEED_DATE'), // 需求日期
                        key: 'needByDate',
                        minWidth: 100,
                        align: 'center',
                    },
                    {
                        title: this.$t('ApplyReceiveMgnView.ITEM_CODE'), // 材料编码
                        key: 'itemCode',
                        minWidth: 100,
                        align: 'center',
                    },
                    {
                        renderHeader: (h) => {
                            return h('div', [
                                h('Tooltip', {
                                    props: {
                                        content: '（采购订单数量 - 已接收数量 - 已请领数量）',
                                        transfer: true,
                                    },
                                }, [
                                    h('span', '剩余可请领数量'),
                                    h('Icon', {
                                        props: {
                                            size: 25,
                                            type: 'm-icon m-icon-android-alert',
                                        },
                                        style: {
                                            color: 'rgb(235 231 20)',
                                            marginLeft: '5px',
                                        },
                                    }),
                                ]),
                            ]);
                        },
                        key: 'availableQty',
                        minWidth: 100,
                        align: 'right',
                    },
                    {
                        title: this.$t('QueryStoreToolView.storeCount'), // 数量
                        key: 'qty',
                        minWidth: 100,
                        align: 'right',
                        render: (h, params) => {
                            const { availableQty: maxQty, qty } = params.row;
                            if (this.showApproval || !this.isDRAFT || this.readOnly) {
                                return h('span', params.row.qty);
                            }
                            return h('Input', {
                                props: {
                                    size: 'small',
                                    value: params.row.qty,
                                },
                                style: {
                                    width: '100%',
                                },
                                on: {
                                    'on-blur': (event) => {
                                        const { value } = event.target;
                                        if (!this.qtyRule.test(value)) {
                                            this.$Modal.error({
                                                title: this.$t('common.warn'),
                                                content: this.$t('importNoticeCommon.t131'), // 请输入正确的数量
                                            });
                                            event.target.value = qty;
                                            params.row.qty = qty;
                                        }
                                        if (+event.target.value > maxQty) {
                                            event.target.value = maxQty;
                                            params.row.qty = maxQty;
                                        }
                                        params.row.qty = event.target.value;
                                        this.poMod.tableData[params.index] = params.row;
                                    },
                                },
                            });

                        },
                    },
                    {
                        title: this.$t('ApplyReceiveMgnView.ITEM_NAME'), // 材料描述
                        key: 'itemDesc',
                        minWidth: 150,
                        tooltip: true,
                    },
                    {
                        title: this.$t('processInspectionSearch.t3'), // 采购订单行号
                        key: 'ierpPoLineNo',
                        minWidth: 100,
                        align: 'center',
                    },
                    {
                        title: this.$t('createDeliveryOrderByOrder.t48'), // 进口通知书号
                        key: 'imptNumber',
                        minWidth: 100,
                        align: 'center',
                    },
                    {
                        title: this.$t('invoiceMonitoring.t12'), // 进口通知书状态
                        key: 'imptStatus',
                        minWidth: 100,
                        align: 'center',
                        render: (h, params) => {
                            const { imptStatus } = params.row;
                            return h('span', this.INT_WX_IMPT_STATUS.find((item) => item.value === imptStatus).label);
                        },
                    },
                    {
                        title: this.$t('createDeliveryOrderByOrder.t18'), // 报关单号
                        key: 'customsNumber',
                        minWidth: 100,
                        align: 'center',
                    },
                ],
                tableData: [],
                selection: [],
            },
            cNoModal: {
                show: false,
                columns: [
                    {
                        type: 'selection',
                        width: 35,
                        align: 'center',
                    },
                    // {
                    //     title: this.$t('createDeliveryOrderByOrder.t1'), // 库存组织
                    //     key: 'organizationCode',
                    //     minWidth: 100,
                    //     align: 'center',
                    // },
                    {
                        title: this.$t('suppliesFormOutside.t7'), // 柜号
                        key: 'container',
                        minWidth: 80,
                        align: 'center',
                    },
                    {
                        title: this.$t('ApplyReceiveMgnView.ITEM_CODE'), // 材料编码
                        key: 'itemCode',
                        minWidth: 80,
                        align: 'center',
                    },
                    {
                        title: this.$t('ApplyReceiveMgnView.ITEM_NAME'), // 材料描述
                        key: 'itemDesc',
                        minWidth: 150,
                        tooltip: true,
                    },
                    {
                        title: this.$t('suppliesFormOutside.t17'), // 本次领料数量
                        key: 'currentQty',
                        minWidth: 50,
                        align: 'right',
                    },
                    {
                        title: this.$t('suppliesFormOutside.t18'), // OMS发票数量
                        key: 'singQty',
                        minWidth: 50,
                        align: 'right',
                    },
                    {
                        title: this.$t('importNoticeCommon.t144'), // OMS发票号
                        key: 'omsInvoiceNo',
                        minWidth: 100,
                        align: 'center',
                    },
                    {
                        title: this.$t('importNoticeCommon.t156'), // 错误原因
                        key: 'unavailableReason',
                        minWidth: 250,
                        tooltip: true,
                        render: (h, params) => {
                            const { unavailableReason } = params.row;
                            return h('Tooltip', {
                                props: {
                                    content: unavailableReason,
                                    placement: 'top',
                                },
                            }, [
                                h('span', {
                                    style: {
                                        color: 'red',
                                    },
                                }, unavailableReason),
                            ]);
                        },
                    },
                ],
                tableData: [],
                selection: [],
                form: {
                    containers: '',
                },
                rules: {
                    containers: [
                        { required: true, message: this.$t('gscInvoice.t104'), trigger: 'change' },
                    ],
                },
                loading: false,
            },
            factoryMod: {
                columns: [
                    {
                        type: 'selection',
                        width: 35,
                        align: 'center',
                    },
                    {
                        title: this.$t('ApplyReceiveMgnView.ITEM_CODE'), // 材料编码
                        key: 'itemCode',
                        minWidth: 110,
                        align: 'center',
                    },
                    {
                        title: this.$t('ApplyReceiveMgnView.ITEM_NAME'), // 材料描述
                        key: 'itemDesc',
                        minWidth: 150,
                        tooltip: true,
                    },
                    {
                        title: this.$t('ApplyReceiveMgnView.COLLECT_NEED_QTY'), // 需求数量
                        key: 'needByQty',
                        minWidth: 80,
                        align: 'right',
                    },
                    {
                        title: this.$t('累计领料数量'),
                        key: 'totalSendQty',
                        minWidth: 80,
                        align: 'right',
                    },
                    {
                        title: this.$t('ApplyReceiveMgnView.OUT_QTY'), // 已领料数量
                        key: 'sendQty',
                        minWidth: 80,
                        align: 'right',
                    },
                    {
                        title: this.$t('ApplyReceiveMgnView.ISSUED_QTY'), // 已制单数量
                        key: 'usedQty',
                        minWidth: 80,
                        align: 'right',
                    },
                    {
                        title: this.$t('ApplyReceiveMgnView.NOT_QTY'), // 未领料数量
                        key: 'remainQty',
                        minWidth: 80,
                        align: 'right',
                    },
                    {
                        title: this.$t('UIDLabelPrint.t15'), // 最小包装数量
                        key: 'fixedLotMultiplier',
                        minWidth: 80,
                        align: 'right',
                    },
                    {
                        renderHeader: (h) => {
                            // 本次退料数  suppliesFormOutside.t37
                            // 本次领料数量 suppliesFormOutside.t17
                            const name = ['suppliesFormOutside.t17', 'suppliesFormOutside.t17', 'suppliesFormOutside.t37'];
                            return h('span', this.$t(name[this.suppForm.orderType ? this.suppForm.orderType - 1 : 0]));
                        },
                        title: this.$t('ApplyReceiveMgnView.THIS_TIME_QTY2'), // 本次领/退料数量
                        key: 'qty',
                        minWidth: 100,
                        align: 'right',
                        render: (h, params) => {
                            if (!this.factoryModal.show) {
                                return h('span', params.row.qty);
                            }
                            return h('Input', {
                                props: {
                                    type: 'text',
                                    size: 'small',
                                    value: params.row.qty,
                                    disabled: this.showApproval || !this.isDRAFT,
                                },
                                on: {
                                    'on-blur': (event) => {
                                        let { value } = event.target;
                                        const { maxQty } = params.row;
                                        if ((!this.qtyRule.test(value) || value <= 0) && value !== '') {
                                            this.$Modal.error({
                                                title: this.$t('common.warn'),
                                                content: this.$t('importNoticeCommon.t131'), // 请输入正确的数量
                                            });
                                            event.target.value = '';
                                            params.row.qty = '';
                                        } else {
                                            if (maxQty && maxQty < value && value !== '') {
                                                this.$Modal.error({
                                                    title: this.$t('common.warn'),
                                                    content: `${this.$t('processInspectionSearch.t93')}${maxQty}`, // 本次维护数量不能大于xxx
                                                });
                                                event.target.value = maxQty;
                                                value = maxQty;
                                            }
                                            // if (value > remainQty) {
                                            //     event.target.value = remainQty;
                                            //     value = remainQty;
                                            // }
                                            params.row.qty = value;
                                        }
                                        this.factoryModal.tableData[params.index] = params.row;
                                    },
                                },
                            });
                        },
                    },
                    {
                        title: this.$t('ApplyReceiveMgnView.NEED_DATE'), // 需求日期
                        key: 'needByDate',
                        minWidth: 100,
                        align: 'center',
                        tooltip: true,
                    },
                    {
                        title: this.$t('suppliesFormOutside.t20'), // 外协工单号
                        key: 'wipEntityName',
                        minWidth: 100,
                        align: 'center',
                        tooltip: true,
                    },
                    {
                        title: this.$t('ApplyReceiveMgnView.PRIMARY_ITEM_CODE'), // 装配件编码
                        key: 'goodsCode',
                        minWidth: 110,
                        align: 'center',
                    },
                    {
                        title: this.$t('suppliesFormOutside.t22'), // 装配件名称
                        key: 'goodsName',
                        minWidth: 150,
                        tooltip: true,
                    },
                    {
                        title: this.$t('ApplyReceiveMgnView.STATUS_TYPE'), // 工单状态
                        key: 'entityStatus',
                        minWidth: 100,
                        align: 'center',
                    },
                    {
                        title: this.$t('供应子库'),
                        key: 'supplySubinventory',
                        width: 120,
                        align: 'center',
                    },
                    {
                        title: this.$t('createDeliveryOrderByOrder.t26'), // 仓管员
                        key: 'warehouseKeeper',
                        width: 120,
                        align: 'center',
                    },
                ],
                tableData: [],
                selection: [],
            },
            factoryModal: {
                show: false,
                formData: {
                    row: 2,
                    items: [
                        {
                            value: '',
                            field: 'wipEntityName',
                            layout: {
                                span: 8,
                                offset: 0,
                                row: 1,
                            },
                            options: {
                                rows: 1,
                                type: 'text',
                            },
                            type: 'text',
                            title: this.$t('ApplyReceiveMgnView.WIP_ENTITY_NAME'), // 委外工单号
                        },
                        {
                            value: '',
                            field: 'itemCode',
                            layout: {
                                span: 8,
                                offset: 0,
                                row: 1,
                            },
                            options: {
                                rows: 1,
                                type: 'text',
                            },
                            type: 'text',
                            title: this.$t('deliveryNoticeConfirm.t11'), // 物料编码
                        },
                        {
                            value: '',
                            field: 'goodsCode',
                            layout: {
                                span: 8,
                                offset: 0,
                                row: 1,
                            },
                            options: {
                                rows: 1,
                                type: 'text',
                            },
                            type: 'text',
                            title: this.$t('ApplyReceiveMgnView.PRIMARY_ITEM_CODE'), // 装配件编码
                        },
                        {
                            value: '',
                            field: 'needByDateBegin',
                            layout: {
                                row: 1,
                                span: 8,
                                offset: 0,
                            },
                            style: 'width:100%',
                            options: {
                                type: 'date',
                                format: 'yyyy-MM-dd',
                                needFormat: false,
                                options: {
                                },
                            },
                            type: 'datePicker',
                            title: this.$t('createDeliveryOrderByOrder.t2'), // 需求时间
                            isDouble: true,
                        },
                        {
                            hide: true,
                            value: '',
                            field: 'needByDateEnd',
                            style: 'width:100%',
                            layout: {
                                span: 4,
                                offset: 0,
                                row: 1,
                            },
                            options: {
                                type: 'date',
                                format: 'yyyy-MM-dd',
                                needFormat: false,
                                options: {
                                },
                            },
                            type: 'datePicker',
                            title: '',
                        },
                    ],
                },
                columns: {
                    columns: [
                        {
                            label: this.$t('common.exportExcelBtn'), // 导出
                            type: 'primary',
                            icon: 'archive',
                            size: 'small',
                            loading: false,
                            click: (button) => {
                                this.$refs.factoryModalTab.validate(async (valid) => {
                                    if (valid) {
                                        button.loading = true;
                                        await this.exportSearchWxRefund();
                                        button.loading = false;
                                    }
                                });
                            },
                        },
                    ],
                },
                tableData: [],
                selection: [],
                loading: false,
                settings: {
                    needPager: false,
                    showElevator: true,
                    showSizer: true,
                    pageSizeOpts: [10, 20, 50, 100],
                    needSearch: true,
                    needValidation: true,
                    currentPage: 1,
                    pageSize: 10,
                    total: null,
                    submitLoading: false,
                },
                tableButtons: {
                    customButtons: [

                    ],
                },
            },
            INT_WX_BUYER_APPROVED: [],
            poModal: {
                show2: false,
                formData: {
                    row: 1,
                    items: [
                        {
                            value: '',
                            field: 'poNumber',
                            layout: {
                                span: 8,
                                offset: 0,
                                row: 1,
                            },
                            options: {
                                rows: 1,
                                type: 'text',
                            },
                            type: 'text',
                            title: this.$t('importNoticeCommon.t50'), // PO号
                        },
                        {
                            value: '',
                            field: 'itemCode',
                            layout: {
                                span: 8,
                                offset: 0,
                                row: 1,
                            },
                            options: {
                                rows: 1,
                                type: 'text',
                            },
                            type: 'text',
                            title: this.$t('deliveryNoticeConfirm.t11'), // 物料编码
                        },
                        {
                            value: '',
                            field: 'poCreateDateBegin',
                            layout: {
                                row: 1,
                                span: 8,
                                offset: 0,
                            },
                            style: 'width:100%',
                            options: {
                                type: 'date',
                                format: 'yyyy-MM-dd',
                                needFormat: false,
                                options: {
                                },
                            },
                            type: 'datePicker',
                            title: this.$t('suppliesFormOutside.t31'), // PO创建时间
                            isDouble: true,
                        },
                        {
                            hide: true,
                            value: '',
                            field: 'poCreateDateEnd',
                            style: 'width:100%',
                            layout: {
                                span: 4,
                                offset: 0,
                                row: 1,
                            },
                            options: {
                                type: 'date',
                                format: 'yyyy-MM-dd',
                                needFormat: false,
                                options: {
                                },
                            },
                            type: 'datePicker',
                            title: '',
                        },
                    ],
                },
                columns: [
                    {
                        type: 'selection',
                        width: 35,
                        align: 'center',
                    },
                    {
                        title: this.$t('createDeliveryOrderByOrder.t1'), // 库存组织
                        key: 'organizationCode',
                        minWidth: 100,
                        align: 'center',
                    },
                    {
                        title: this.$t('importNoticeCommon.t50'), // PO号
                        key: 'poNumber',
                        minWidth: 150,
                        align: 'center',
                    },
                    {
                        title: this.$t('importNoticeCommon.t51'), // PO行号
                        key: 'lineNum',
                        minWidth: 80,
                        align: 'center',
                    },
                    {
                        title: this.$t('ApplyReceiveMgnView.ITEM_CODE'), // 材料编码
                        key: 'itemCode',
                        minWidth: 150,
                        align: 'center',
                    },
                    {
                        title: this.$t('ApplyReceiveMgnView.ITEM_NAME'), // 材料描述
                        key: 'itemDesc',
                        minWidth: 200,
                        tooltip: true,
                    },
                    {
                        renderHeader: (h) => {
                            return h('span', [
                                h('span', {
                                    style: {
                                        color: '#FF0000',
                                    },
                                }, '* '),
                                h('span', this.$t('suppliesFormOutside.t7')),
                            ]);
                        }, // 柜号
                        title: this.$t('suppliesFormOutside.t7'),
                        key: 'container',
                        minWidth: 150,
                        align: 'center',
                        render: (h, params) => {
                            const options = this.containerList.map((item) => {
                                return h('Option', {
                                    props: {
                                        value: item,
                                        label: item,
                                    },
                                });
                            });
                            return h('Select', {
                                props: {
                                    size: 'small',
                                    transfer: true,
                                    value: params.row.container,
                                },
                                on: {
                                    'on-change': (val) => {
                                        const { container, omsInvoiceNo } = this.cNoMod.tableData.find((item) => item.container === val);
                                        Object.assign(params.row, {
                                            container,
                                            omsInvoiceNo,
                                        });
                                        this.poModal.tableData[params.index] = params.row;
                                        this.gridApi.getRowNode(params.index).setData(params.row);
                                    },
                                },
                            }, options);
                        },
                    },
                    {
                        title: this.$t('importNoticeCommon.t115'), // PO数量
                        key: 'qty',
                        minWidth: 100,
                        align: 'right',
                        render: (h, params) => {
                            const { maxQty, qty } = params.row;
                            return h('Input', {
                                props: {
                                    size: 'small',
                                    value: params.row.qty,
                                },
                                style: {
                                    width: '100%',
                                },
                                on: {
                                    'on-blur': (event) => {
                                        const { value } = event.target;
                                        if (!this.qtyRule.test(value)) {
                                            this.$Modal.error({
                                                title: this.$t('common.warn'),
                                                content: this.$t('importNoticeCommon.t131'), // 请输入正确的数量
                                            });
                                            event.target.value = qty;
                                            params.row.qty = qty;
                                        }
                                        if (+event.target.value > maxQty) {
                                            event.target.value = maxQty;
                                            params.row.qty = maxQty;
                                        }
                                        params.row.qty = event.target.value;
                                        this.poModal.tableData[params.index] = params.row;
                                        this.gridApi.getRowNode(params.index).setData(params.row);
                                        this.poModal.selection = this.gridApi.getSelectedRows();
                                    },
                                },
                            });
                        },
                    },
                ],
                tableData: [],
                loading: false,
                settings: {
                    needPager: false,
                    showElevator: true,
                    showSizer: true,
                    pageSizeOpts: [10, 20, 50, 100],
                    needSearch: true,
                    needValidation: true,
                    currentPage: 1,
                    pageSize: 10,
                    total: null,
                    submitLoading: false,
                },
                selection: [],
            },
            gridApi: null,
            qtyRule: /^[0-9]+\.?[0-9]{0,3}$/,
        };
    },
    methods: {
        /* 组织选择 */
        orgOnChange(val) {
            Object.assign(this.suppForm, {
                approvalUser: '',
            });
            /* INT_WX_RECEIVE_MATERIAL字典内组织默认“工厂领料” */
            if (!this.headerId && this.INT_WX_RECEIVE_MATERIAL.some((item) => item.code === val)) {
                this.suppForm.wxMode = 'FACTORY_MATERIAL_REQUISITION';
            }
        },
        cNoSelectFun(selection, checkVal) {
            /* 自动勾选相同箱号的数据 */
            // eslint-disable-next-line prefer-destructuring
            const cNoTable = this.$refs.cNoTable;
            const { objData } = cNoTable;
            const ids = selection.map((item) => item.container);
            this.$nextTick(() => {
                Object.keys(objData).forEach((key) => {
                    if (ids.includes(objData[key].container)) {
                        // eslint-disable-next-line no-underscore-dangle
                        objData[key]._isChecked = checkVal;
                    }
                });
                this.cNoMod.selection = cNoTable.getSelection();
            });
        },
        cNoSelectAllCancel(selection) {
            if (selection.length === 0) {
                this.cNoMod.selection = [];
            }
        },
        cNoSelectAll(selection) {
            this.cNoMod.selection = selection;
        },
        cNoSelect(selection) {
            /* 自动勾选相同柜号数据 */
            this.cNoSelectFun(selection, true);
        },
        cNoSelectCancel(selection, row) {
            /* 自动取消相同柜号数据 */
            this.cNoSelectFun([row], false);
        },
        cNoModalSelectChange(selection) {
            this.cNoModal.selection = selection;
        },
        factoryModSelectChange(selection) {
            this.factoryMod.selection = selection;
        },
        factOnSubmit() {
            this.factoryModal.loading = true;
            this.postApi('/gscint/req/searchFactoryWx', {
                headerId: this.headerId,
                organizationCode: this.suppForm.organizationCode,
                vendorCode: this.vendorCode,
                ...this.getFormDataVModel(this.factoryModal.formData.items),
                language: langParams(this.$i18n.locale),
                orderType: this.factoryType ? this.suppForm.orderType : undefined,
            }, (data) => {
                this.factoryModal.tableData = data;
            })
                .finally(() => {
                    this.factoryModal.loading = false;
                });
        },
        factOnSelectionChange(selection) {
            this.factoryModal.selection = selection;
        },
        /* 删除柜子 */
        removeContainer() {
            this.$Modal.confirm({
                content: this.$t('suppliesFormOutside.t28'), // 确定要删除柜子吗？
                onOk: () => {
                    setTimeout(() => {
                        this.loading = true;
                        this.postApi('/gscint/req/removeContainer', {
                            headerId: this.headerId,
                            containerList: Array.from(new Set([...this.cNoMod.selection.map((item) => item.container)])),
                        }, () => {
                            this.$Modal.success({
                                content: this.$t('index.common.delete_success'), // 删除成功
                            });
                            this.queryDetail();
                        })
                            .finally(() => {
                                this.loading = false;
                            });
                    }, 400);
                },
            });
        },
        submit() {
            this.$Modal.confirm({
                content: this.$t('suppliesFormOutside.t30'), // 确定要提交审批吗？
                onOk: async () => {
                    if (!this.factoryType) {
                        await this.updateHeader(false);
                    }
                    this.loading = true;
                    this.getApi('/gscint/req/submit', {
                        headerId: this.headerId,
                    }, ({ noNeedCreateIflow }) => {
                        if (!noNeedCreateIflow) {
                            this.createProcessDraft();
                        } else {
                            this.submitSussess();
                        }
                    })
                        .catch(() => {
                            this.loading = false;
                        });
                },
            });
        },
        /* 柜号导出 */
        cNoModalExport() {
            this.$refs.cNoForm.validate((valid) => {
                if (valid) {
                    this.cNoModal.loading = true;
                    exportExcel('/gscint/req/exportInvoice', {
                        organizationCode: this.suppForm.organizationCode,
                        vendorCode: this.vendorCode,
                        containers: this.cNoModal.form.containers,
                        language: langParams(this.$i18n.locale),
                    }, `${this.$t('suppliesFormOutside.t7')}${moment().format('YYYY-MM-DD')}.xlsx`, this)
                        .finally(() => {
                            this.cNoModal.loading = false;
                        });
                }
            });
        },
        /* 查询柜号 */
        queryInvoice() {
            this.$refs.cNoForm.validate((valid) => {
                if (valid) {
                    this.cNoModal.loading = true;
                    this.postApi('/gscint/req/queryInvoice', {
                        headerId: this.headerId,
                        organizationCode: this.suppForm.organizationCode,
                        vendorCode: this.vendorCode,
                        containers: this.cNoModal.form.containers,
                        language: langParams(this.$i18n.locale),
                    }, (data) => {
                        this.cNoModal.tableData = data;
                        this.$nextTick(() => {
                            const { objData } = this.$refs.cNoModalTab;
                            Object.keys(objData).forEach((key) => {
                                if (objData[key].available === 'N') {
                                    objData[key]._isDisabled = true;
                                } else {
                                    objData[key]._isChecked = true;
                                    this.cNoModal.selection.push(objData[key]);
                                }
                            });
                        });
                    })
                        .finally(() => {
                            this.cNoModal.loading = false;
                        });
                }
            });
        },
        cNoModalAdd() {
            this.$refs.suppForm.validate((valid) => {
                if (valid) {
                    this.cNoModal.show = true;
                }
            });
        },
        openOrUpdateDetail(headerId) {
            if (!this.headerId) {
                this.$closeTab({
                    name: 'suppliesFormOutsideAdd',
                });
                this.$router.push({
                    name: 'suppliesFormOutsideEdit',
                    query: {
                        headerId,
                    },
                });
            } else {
                this.queryDetail(headerId);
            }
        },
        /* 柜号确定选择 */
        cNoModalConfirm() {
            this.cNoModal.loading = true;
            this.postApi('/gscint/req/addContainer', {
                header: {
                    headerId: this.headerId || '',
                    ...this.suppForm,
                    vendorCode: this.vendorCode,
                },
                invoiceList: this.cNoModal.tableData,
            }, (headerId) => {
                this.openOrUpdateDetail(headerId);
                this.cNoModal.show = false;
                // if (!this.headerId) {
                //     this.$closeTab({
                //         name: 'suppliesFormOutsideAdd',
                //     });
                //     this.$router.push({
                //         name: 'suppliesFormOutsideEdit',
                //         query: {
                //             headerId,
                //         },
                //     });
                // } else {
                //     this.cNoModal.show = false;
                //     // this.suppForm.containers;
                //     this.queryDetail(headerId);
                // }
            })
                .finally(() => {
                    this.cNoModal.loading = false;
                });
        },
        /* 获取明细数据 */
        queryDetail(headerId) {
            this.loading = true;
            this.getApi('/gscint/req/queryDetail', {
                headerId: headerId || this.headerId,
            }, (data) => {
                const {
                    header, lineList, summaryLineList, wipLineList,
                } = data;
                Object.assign(this.suppForm, header);
                /* 避免触发select中的on-change方法把数据清空 */
                this.$nextTick(() => {
                    const { approvalUser, orderType } = header;
                    Object.assign(this.suppForm, {
                        approvalUser,
                        orderType,
                    });
                });
                Object.assign(this.poMod, {
                    tableData: lineList,
                    selection: [],
                });
                Object.assign(this.cNoMod, {
                    tableData: summaryLineList,
                    selection: [],
                });
                this.wxMod.tableData = wipLineList;
                this.factoryMod.tableData = wipLineList;
            })
                .finally(() => {
                    this.loading = false;
                });
        },
        exportCommon(url, name) {
            this.loading = true;
            exportExcel(url, {
                headerId: this.headerId,
                language: langParams(this.$i18n.locale),
            }, `${name}${moment().format('YYYY-MM-DD')}.xlsx`, this)
                .finally(() => {
                    this.loading = false;
                });
        },
        exportLine() {
            this.exportCommon('/gscint/req/exportLine', this.$t('route.suppliesFormOutside'));
        },
        back() {
            const name = this.headerId ? 'suppliesFormOutsideEdit' : 'suppliesFormOutsideAdd';
            this.$closeTab({
                name: this.readOnly ? 'suppliesFormOutsideDetail' : name,
            });
            this.$router.push({
                name: 'suppliesFormOutside',
            });
        },
        init() {
            if (this.headerId) {
                this.queryDetail();
            }
            if (this.businessId) {
                this.$refs.approval.searchInfo(this.businessId, 'gscIRequestLead', '');
            }
        },
        /* 创建流程 */
        createProcessDraft() {
            this.loading = true;
            const subjectTitle = this.approvalTitle;
            const subjectForMultiLanguages = [
                {
                    languageType: 'zh-CN',
                    subject: `国际外协请领审批流程【申请单号：${this.suppForm.requestLeadCode}】`,
                },
            ];
            debugger;
            if (this.$i18n.locale !== 'zh-CN') {
                subjectForMultiLanguages.push({
                    languageType: 'en-US',
                    subject: subjectTitle,
                });
            }
            axios.post('/mip/workFlow/createProcessDraft', {
                businessKey: 'gscIRequestLead',
                loginName: this.$store.state.user.loginName,
                subjectTitle,
                businessId: this.headerId,
                params: '?source=hk',
                subjectForMultiLanguages,
                operationType: 'draft_submit',
            })
                .then((res) => {
                    const { data, status, content } = res.data.data;
                    if (status === 500) {
                        this.$Modal.warning({
                            content,
                        });
                        return;
                    }
                    if (data.resultCode === 'SUCCESS') {
                        this.submitSussess();
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        poModalSelect(selection) {
            this.poModal.selection = selection;
        },
        poModalOnSubmit() {
            this.poModal.loading = true;
            this.postApi('/gscint/req/searchPo', {
                vendorCode: this.vendorCode,
                headerId: this.headerId,
                organizationCode: this.suppForm.organizationCode,
                ...this.getFormDataVModel(this.poModal.formData.items),
            }, (data) => {
                data.forEach((item) => {
                    item.maxQty = item.qty;
                });
                this.poModal.tableData = data;
                // this.poModal.tableData = [];
                // setTimeout(() => {
                //     this.poModal.tableData = data;
                // }, 100);
            })
                .finally(() => {
                    this.poModal.loading = false;
                });
        },
        addPo(poAddLineList) {
            this.poModal.loading = true;
            this.postApi('/gscint/req/addPo', {
                headerId: this.headerId,
                poAddLineList,
            }, () => {
                this.queryDetail();
            })
                .finally(() => {
                    this.poModal.loading = false;
                });
        },
        poModalConfirm() {
            const selection = this.gridApi.getSelectedRows();
            if (selection.some((item) => !item.container)) {
                this.$Modal.warning({
                    content: this.$t('suppliesFormOutside.t32'), // 请选择柜号后再进行确认
                });
                return;
            }
            this.poModal.show2 = false;
            this.addPo(selection.map(({ poLineId, container, omsInvoiceNo, qty }) => {
                return {
                    poLineId,
                    container,
                    omsInvoiceNo,
                    qty,
                };
            }));
        },
        poModSelect(selection) {
            this.poMod.selection = selection;
        },
        /* 删除采购订单 */
        removePo() {
            this.removeLine('/gscint/req/removePo', this.poMod.selection.map((item) => item.lineId));
        },
        onFirstDataRendered(params) {
            this.gridApi = params.api;
        },
        onRowDataUpdated() {
            // this.getRowId = (row) => row.data.poLineId;
        },
        handleDeelSubmit() {
            window.location.reload();
        },
        /* 驳回重新提交回调 */
        afterProcessSubmit() {
            window.location.reload();
        },
        handleReturnBtn() {
            if (this.$route.query.source === 'gsc') {
                this.$closeTab({
                    name: 'suppliesFormOutsideDetail',
                });
                this.$closeTab({
                    name: 'suppliesFormOutsideEdit',
                });
                this.$router.push({
                    name: 'suppliesFormOutside',
                });
            } else {
                window.location.reload();
            }
        },
        wxModeChange() {
            this.suppForm.orderType = '';
        },
        factoryModalOpen() {
            this.$refs.suppForm.validate((valid) => {
                if (valid) {
                    this.factoryModal.show = true;
                }
            });
        },
        factoryConfirm() {
            const wipLineList = this.$refs.factoryModalTab.getSelection();
            if (wipLineList.some((item) => !item.qty)) {
                this.$Modal.warning({
                    content: `${this.$t('ApplyReceiveMgnView.THIS_TIME_QTY2')} ${this.$t('createDeliveryOrderToInformView.t49')}`, // 本次领/退料数量不能为空
                });
                return;
            }
            this.factoryModal.loading = true;
            const {
                organizationCode, wxMode, orderType, approvalUser,
            } = this.suppForm;
            this.postApi('/gscint/req/addFactoryWx', {
                header: {
                    headerId: this.headerId,
                    organizationCode,
                    wxMode,
                    orderType,
                    approvalUser,
                    vendorCode: this.vendorCode,
                },
                wipLineList,
            }, (headerId, others) => {
                this.openOrUpdateDetail(headerId);
                this.factoryModal.show = false;
                if (others?.extras?.tips) {
                    this.$Modal.warning({
                        content: others.extras.tips,
                    });
                }
            })
                .finally(() => {
                    this.factoryModal.loading = false;
                });
        },
        /* 委外工单删除 */
        removeFactory() {
            this.removeLine('/gscint/req/removeWxRefund', this.factoryMod.selection.map((item) => item.lineId));
        },
        /* 委外工单导出 */
        exportSearchWxRefund() {
            exportExcel('/gscint/req/exportSearchFactoryWx', {
                headerId: this.headerId,
                organizationCode: this.suppForm.organizationCode,
                vendorCode: this.vendorCode,
                ...this.getFormDataVModel(this.factoryModal.formData.items),
                orderType: this.factoryType ? this.suppForm.orderType : undefined,
                language: langParams(this.$i18n.locale),
            }, `${this.$t('suppliesFormOutside.t34')}${moment().format('YYYY-MM-DD')}.xlsx`, this); // 委外工单导出
        },
        removeLine(url, lineIdList) {
            this.$Modal.confirm({
                content: this.$t('gscInvoice.t107'), // 确定要删除吗？
                onOk: () => {
                    setTimeout(() => {
                        this.loading = true;
                        this.postApi(url, {
                            headerId: this.headerId,
                            lineIdList,
                        }, () => {
                            this.$Modal.success({
                                content: this.$t('index.common.delete_success'), // 删除成功
                            });
                            this.queryDetail();
                        })
                            .finally(() => {
                                this.loading = false;
                            });
                    }, 400);
                },
            });
        },
        /* 委外工单导出 */
        exportWxRefund() {
            this.exportCommon(`/gscint/req/${this.factoryType ? 'exportSearchFactoryWx' : 'exportWxRefund'}`, this.$t('suppliesFormOutside.t34'));
        },
        updateHeader(updateDetail = true) {
            const {
                contacts, phone, address, approvalUser,
            } = this.suppForm;
            this.loading = true;
            return this.postApi('/gscint/req/updateHeader', {
                headerId: this.headerId,
                contacts,
                phone,
                address,
                approvalUser,
            })
                .then(() => {
                    if (updateDetail) {
                        this.queryDetail();
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        handlerSubmit() {
            this.updateHeader(false);
        },
        containerSet() {
            const newList = this.poModal.tableData.map((item) => {
                item.container = this.containerSetModal.container;
                return item;
            });
            this.poModal.tableData = newList;
            this.containerSetModal.show = false;
        },
        /* 采购订单更新PO数量 */
        updatePo() {
            this.loading = true;
            const list = this.$refs.poModTabRef.getSelection().map(({ lineId, qty }) => {
                return {
                    lineId,
                    qty,
                };
            });
            this.postApi('/gscint/req/updatePo', list)
                .then(() => {
                    this.$Modal.success({
                        content: this.$t('gscInvoice.t95'),
                    });
                    this.queryDetail();
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        submitSussess() {
            this.$Modal.success({
                content: this.$t('gscInvoice.t101'), // 提交成功
            });
            this.$closeTab({
                name: 'suppliesFormOutsideEdit',
            });
            this.$nextTick(() => {
                this.$router.push({
                    name: 'suppliesFormOutside',
                });
            });
        },
    },
    mounted() {
        this.factoryModal.columns.columns = this.factoryMod.columns;
        this.init();
        this.getDictByCode('INT_WX_NO_APPROVE');
        this.getDictByCode('INT_WX_RECEIVE_MATERIAL');
        // this.getRowId = (row) => row.data.poLineId;
    },
    activated() {
        this.init();
    },
};
</script>
<style lang="less" scoped>
.layout {
    padding: 10px;
    background: #FFF;
}
.mt10 {
    margin-top: 10px;
}
.mr10 {
    margin-right: 10px;
}
.c1 {
    color: red;
}
.tr {
    text-align: right;
}
/deep/ .m-select-disabled .m-select-selected-value, /deep/ .m-input-wrapper .m-input[disabled] {
        color: #000;
}
</style>
